import { render } from "./myTextEllipsis.vue?vue&type=template&id=916e7c74&scoped=true"
import script from "./myTextEllipsis.vue?vue&type=script&lang=js"
export * from "./myTextEllipsis.vue?vue&type=script&lang=js"

import "./myTextEllipsis.vue?vue&type=style&index=0&id=916e7c74&lang=scss&scoped=true"

import exportComponent from "D:\\gitLab\\daily\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916e7c74"]])

export default __exports__